import Api from '@/services/Api'

export default {
  authorize (manipName) {
    return Api().post(`authorize/${manipName}`);
  }
}